import { Component, OnInit, Input } from '@angular/core';
import { ErrorType } from '@models/error-type';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent implements OnInit {
  @Input() errorTitle: string;
  @Input() errorDescription: string;
  @Input() errorType: ErrorType;

  get swalErrorType() {
    return `swal2-${this.errorType || 'warning'}`;
  }

  constructor() {}

  ngOnInit() {}
}
